// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4247":"a9b686b3","7336":"a9b686b3"}[chunkId] + ".chunk.css";
};